import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { validarSize } from 'src/app/common/validation-utils';

export interface SucursalResponse {
  cdsucursal: string;
  dssucursal: string;
}

export interface SucursalPageResponse {
  content: SucursalResponse[];
  totalElements: number;
  nextCursor?: string;
  previousCursor?: string;
  hasNext: boolean;
  hasPrevious: boolean;
}

export abstract class SucursalRepository {
  /**
   * @param cdoficina modo línea de atención: TPSC_OFICINAS.CDOFICINA de la oficina de la
   *                  orden (legacy líneas 552-557, valor tras el ';' de lbOficinaOrden).
   *                  Se omite en el resto de modos.
   */
  abstract buscar(
    npoliza: string,
    codigo: string | undefined,
    nombre: string | undefined,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST',
    cdoficina?: string
  ): Promise<SucursalPageResponse>;
}

/**
 * Adaptador HTTP para búsqueda de sucursales por póliza en Sin Orientación de Servicio.
 *
 * Endpoint: GET /api/servicios/sin-oc/sucursales/buscar
 * Tabla: T094_SUCURSALES (NPOLIZA = ? AND FEBAJA IS NULL)
 * Paginación keyset/cursor (skill acceso-datos-oracle §7 — nunca OFFSET).
 *
 * Legacy: CumplimientoSinOcViewImpl.crearBuscadorDinamico() línea 562
 */
@Injectable({ providedIn: 'root' })
export class HttpSucursalRepository extends SucursalRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/sin-oc/sucursales/buscar`;

  async buscar(
    npoliza: string,
    codigo: string | undefined,
    nombre: string | undefined,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST',
    cdoficina?: string
  ): Promise<SucursalPageResponse> {
    validarSize(size);
    let params = new HttpParams()
      .set('npoliza', npoliza.trim())
      .set('size', String(size))
      .set('direction', direction);

    if (codigo?.trim()) params = params.set('codigo', codigo.trim());
    if (nombre?.trim())  params = params.set('nombre',  nombre.trim());
    if (cdoficina?.trim()) params = params.set('cdoficina', cdoficina.trim());
    if (cursor) params = params.set('cursor', cursor);

    return firstValueFrom(
      this.http.get<SucursalPageResponse>(this.baseUrl, { params })
    );
  }
}
